import { ProductCard } from './product_card';

export default ProductCard;
